var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import id from "@irati/utils/id";
import { hangPromise } from "@irati/utils/promise";
import { injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import { Container, StyledH4 } from "../styled";
var PerkAvailableBlock = /** @class */ (function (_super) {
    __extends(PerkAvailableBlock, _super);
    function PerkAvailableBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise()
        };
        _this.componentDidMount = function () {
            setTimeout(function () {
                _this.setState({ load: Promise.resolve() });
            }, 1000);
        };
        return _this;
    }
    PerkAvailableBlock.prototype.render = function () {
        var _a = this.props, redeemButtonText = _a.redeemButtonText, redeemButtonDisabled = _a.redeemButtonDisabled, redeemHeaderEmoji = _a.redeemHeaderEmoji, onClickRedeem = _a.onClickRedeem, formatMessage = _a.formatMessage;
        var redeemHeaderText = formatMessage({ id: "perks.redemptionEvents.timeToRedeemBlock.header" });
        return (React.createElement(Container, null,
            React.createElement(Loading, { load: this.state.load },
                React.createElement(StyledH4, { marginBottom: 2 }, redeemHeaderEmoji + " " + redeemHeaderText),
                React.createElement(ButtonRouterLink, { id: id("getThisPerk", this.props), primary: true, large: true, full: true, async: true, onClick: onClickRedeem, disabled: !!redeemButtonDisabled }, redeemButtonText))));
    };
    PerkAvailableBlock.defaultProps = {
        redeemHeaderEmoji: ""
    };
    return PerkAvailableBlock;
}(PureComponent));
export default injectIntl(PerkAvailableBlock);
